export function TabsBox({ children, title, icon }: any) {
    return children;
  }